import React, {useState, useEffect} from "react";
import Button from "react-bootstrap/Button";
import ApiService from "../util/ApiService";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import CustomPagination from "../util/CustomPagination";
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import HospitalDepartmentRegisterModal from "./HospitalDepartmentRegisterModal";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import HospitalSearch from "./HospitalSearch";

const HospitalDepartmentModal = ({show, handleClose, hospital, department}) => {

    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [hospitalSelect, setHospitalSelect] = useState([]);
    const [showDepartmentHospitalRegister, setShowDepartmentHospitalRegister] = useState(false);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [hospitalsDepartment, setHospitalsDepartment] = useState([]);
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState({
        department_id: department?.value || "",
    });

    const semanasMap = {
        1: '1ª Semana', 2: '2ª Semana', 3: '3ª Semana', 4: '4ª Semana', 5: '5ª Semana',
    };

    const diasSemanaMap = {
        0: 'Domingo', 1: 'Segunda', 2: 'Terça', 3: 'Quarta', 4: 'Quinta', 5: 'Sexta', 6: 'Sábado'
    };

    const fetchDepartment = async () => {
        try {
            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}departments/list-department`,{ all: true, status: 'S'}, true);
            const {data} = ApiService.handleApiResponse(response);
            const options = data.map(specialty => ({
                value: specialty.id,
                label: specialty.name,
            }));
            setDepartmentOptions(options);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const fetchDepartmentHospital = async (page = 1) => {
        try {
            setLoading(true);
            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}departments-hospital/list`, {
                per_page: 5,
                page: page,
                hospital_id: hospital?.id || hospitalSelect?.value  || undefined,
                department_id: filters?.department_id || department?.value || undefined
            }, true);
            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setHospitalsDepartment(data);
            setPagination(pagInfo);
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (hospital && show) {
            fetchDepartmentHospital(1);
        }
    }, [show, hospital]);


    useEffect(() => {
            fetchDepartment();
    }, []);

    const handleShowModalRegister = () => {
        setInitialData(null);
        setShowDepartmentHospitalRegister(true);
    };

    const handleHospitalDepartmentRegisterModalClose = (save = false) => {
        setShowDepartmentHospitalRegister(false);
        if(save) fetchDepartmentHospital(pagination.current);
    };

    const handlePageChange = (page) => fetchDepartmentHospital(page);

    const handleFilterChange = (selectedOption) => {
        setFilters({ ...filters, department_id: selectedOption ? selectedOption.value : "" });
    };

    const handleEdit = (hospitalsDepartment) => {
        setInitialData(hospitalsDepartment);
        setShowDepartmentHospitalRegister(true);
    };

    const handleDelete = async (hospitalsDepartment) => {
        const result = await Swal.fire({
            title: 'Deseja realmente excluir?',
            text: "Essa ação não poderá ser desfeita.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Sim, excluir',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                setLoading(true);
                await ApiService.send('delete', `${process.env.REACT_APP_URL_API}departments-hospital/delete`, { id: hospitalsDepartment.id }, true);
                Swal.fire({
                    title: 'Excluído!',
                    text: 'Foi removido com sucesso a vaga cadastrada.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false,
                });
                fetchDepartmentHospital(pagination.current);
            } catch (error) {
                ApiService.handleApiError(error);
            } finally {
                setLoading(false);
            }
        }
    };


    const onHospitalSelect = (hospital) => {
        setHospitalSelect(hospital);
    };

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                centered
                size="xl"
                backdrop="static"
                keyboard={false}
                backdropClassName="custom-backdrop"
                className={`modal-pai ${showDepartmentHospitalRegister ? 'modal-blur' : ''}`}
            >

            <Modal.Header closeButton>
                    <Modal.Title> Vagas de Escala
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="row">
                        <div className="col-6 form-group">
                            <label>Departamento</label>
                            <Select
                                isClearable={true}
                                value={departmentOptions.find(option => option.value === filters.department_id) || department || null}
                                onChange={handleFilterChange}
                                options={departmentOptions}
                                placeholder="Selecione o departamento"
                                classNamePrefix="react-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({...base, zIndex: 9999}),
                                    menu: base => ({...base, zIndex: 9999})
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <HospitalSearch
                                buttonAdd={false}
                                validateManager={true}
                                initialHospital={hospital}
                                onHospitalSelect={onHospitalSelect}
                            />
                        </div>

                        <div className="d-flex justify-content-end mb-3">
                            <button type="button" className="btn btn-success me-2 " onClick={() => fetchDepartmentHospital(1)}>
                                <i className="fa fa-search"></i> Buscar
                            </button>
                            <button type="button" className="btn btn-info" onClick={() => handleShowModalRegister(hospital)}>
                                <i className="fa fa-plus"></i> Cadastrar
                            </button>
                        </div>
                    </div>


                    {loading ? (
                        <Skeleton count={5} height={30} style={{marginBottom: "10px"}}/>
                    ) : (
                        <div className="hospital-list" style={{maxHeight: '400px', overflowY: 'auto'}}>
                        {hospitalsDepartment.length > 0 ? (
                                hospitalsDepartment.map((departmentHospital) => (
                                    <div key={departmentHospital.id}
                                         className="hospital-item d-flex flex-column align-items-start mb-3"
                                         style={{
                                             backgroundColor: '#fff',
                                             borderRadius: '8px',
                                             padding: '15px 20px',
                                             boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                                             borderLeft: '5px solid #20c997'
                                         }}>
                                        <div className="d-flex align-items-center  w-100">
                                            <div className="row col-12  align-items-center">
                                                <div className="d-flex align-items-center">
                                                    <div className="row w-100 align-items-center">
                                                        <div className="row g-2">
                                                            <div className="col-12 col-md-5">
                                                                <h5 className="mb-0 mt-1 d-flex align-items-center"
                                                                    style={{fontSize: '14px', color: '#333'}}>
                                                                    <i className="fa fa-building text-primary me-2"
                                                                       style={{fontSize: '20px', color: '#20c997'}}></i>
                                                                    {departmentHospital.department?.name || 'Departamento não especificado'}
                                                                </h5>

                                                                <h6 className="mb-0 mt-2 d-flex align-items-center"
                                                                    style={{fontSize: '14px', color: '#333'}}>
                                                                    <i className={`fa ${
                                                                        (() => {
                                                                            let semanasSelecionadas = [];

                                                                            try {
                                                                                const raw = departmentHospital.order_month;
                                                                                semanasSelecionadas = Array.isArray(raw)
                                                                                    ? raw.map(Number)
                                                                                    : JSON.parse(raw || '[]').map(Number);
                                                                            } catch (e) {
                                                                                semanasSelecionadas = [];
                                                                            }

                                                                            const isMesInteiro = semanasSelecionadas.includes(0) || [1, 2, 3, 4, 5, 6].every(s => semanasSelecionadas.includes(s));
                                                                            return isMesInteiro ? 'fa-calendar' : 'fa-calendar-week';
                                                                        })()
                                                                    } text-primary me-2`}
                                                                       style={{fontSize: '20px'}}></i>
                                                                    {(() => {
                                                                        let semanasSelecionadas = [];
                                                                        try {
                                                                            const raw = departmentHospital.order_month;
                                                                            semanasSelecionadas = Array.isArray(raw)
                                                                                ? raw.map(Number)
                                                                                : JSON.parse(raw || '[]').map(Number);
                                                                        } catch (e) {
                                                                            semanasSelecionadas = [];
                                                                        }

                                                                        const semanasMap = {
                                                                            1: '1ª semana',
                                                                            2: '2ª semana',
                                                                            3: '3ª semana',
                                                                            4: '4ª semana',
                                                                            5: '5ª semana',
                                                                            6: '6ª semana',
                                                                        };

                                                                        const isMesInteiro = semanasSelecionadas.includes(0) || [1, 2, 3, 4, 5, 6].every(s => semanasSelecionadas.includes(s));

                                                                        return isMesInteiro
                                                                            ? 'Mês inteiro'
                                                                            : semanasSelecionadas.map(val => semanasMap[val]).filter(Boolean).join(', ') || 'Semanas não definidas';
                                                                    })()}
                                                                </h6>

                                                                <h6 className="mb-0 mt-2 d-flex align-items-center"
                                                                    style={{fontSize: '14px', color: '#333'}}>
                                                                    <i className="fa fa-calendar-day text-primary me-2"
                                                                       style={{fontSize: '20px'}}></i>
                                                                    {(() => {
                                                                        const diasSelecionados = JSON.parse(departmentHospital.duty_scale_day_wee_id || '[]') || [];
                                                                        const diasUteis = [1, 2, 3, 4, 5];
                                                                        const finalSemana = [0, 6];
                                                                        const todosDias = [0, 1, 2, 3, 4, 5, 6];
                                                                        const diasSet = new Set(diasSelecionados.map(Number));

                                                                        if (todosDias.every(d => diasSet.has(d))) return 'Semana inteira';
                                                                        if (diasUteis.every(d => diasSet.has(d)) && diasSet.size === diasUteis.length) return 'Segunda a sexta';
                                                                        if (finalSemana.every(d => diasSet.has(d)) && diasSet.size === finalSemana.length) return 'Final de semana';

                                                                        return diasSelecionados.map(val => diasSemanaMap[val]).filter(Boolean).join(', ') || 'Dias não definidos';
                                                                    })()}
                                                                </h6>
                                                            </div>

                                                            <div className="col-6 col-md-2">
                                                                <h6 className="mb-0 mt-1 d-flex align-items-center"
                                                                    style={{fontSize: '14px', color: '#333'}}>
                                                                    <i className="fa fa-user text-info me-2"
                                                                       style={{fontSize: '20px', color: '#fd7e14'}}></i>
                                                                    {departmentHospital.qtde_user || 'N/D'} usuários
                                                                </h6>
                                                            </div>

                                                            <div className="col-12 col-md-6 col-lg-3">
                                                                <h6 className="mb-0 mt-1 d-flex align-items-center"
                                                                    style={{fontSize: '14px', color: '#333'}}>
                                                                    <i className="fa fa-clock text-warning me-2"
                                                                       style={{fontSize: '20px', color: '#fd7e14'}}></i>
                                                                    {departmentHospital.time_start.slice(0, 5)} - {departmentHospital.time_end.slice(0, 5)}
                                                                </h6>
                                                                <h6 className="mb-0 mt-1 d-flex align-items-center"
                                                                    style={{fontSize: '14px', color: '#333'}}>
                                                                    <i className="fa fa-hourglass-half text-warning me-2"
                                                                       style={{fontSize: '20px', color: '#fd7e14'}}></i>
                                                                    {departmentHospital.total_hours.slice(0, 5)}
                                                                </h6>
                                                            </div>

                                                            <div
                                                                className="col-12 col-md-6 col-lg-2 text-md-end text-start d-flex gap-2 mt-2 mt-md-0">
                                                                <Button
                                                                    className="btn btn-info btn-sm me-1"
                                                                    style={{ height: '36px', padding: '4px 12px', fontSize: '10px' }}
                                                                    onClick={() => handleEdit(departmentHospital)}
                                                                >
                                                                    <i className="fa fa-edit"></i> Editar
                                                                </Button>

                                                                <Button
                                                                    className="btn btn-danger btn-sm me-1"
                                                                    style={{ height: '36px', padding: '4px 12px', fontSize: '10px' }}
                                                                    onClick={() => handleDelete(departmentHospital)}
                                                                >
                                                                    <i className="fa fa-close"></i> Excluir
                                                                </Button>

                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="alert alert-info">Hospital sem vagas cadastradas.</div>
                            )}
                            <CustomPagination pagination={pagination} onChange={handlePageChange}/>
                        </div>

                    )}

                    <HospitalDepartmentRegisterModal
                        show={showDepartmentHospitalRegister}
                        onHide={handleHospitalDepartmentRegisterModalClose}
                        hospital={hospital}
                        department={department}

                        initialData={initialData}

                    />

                </Modal.Body>
            </Modal>


        </>
    );
};

export default HospitalDepartmentModal;
